module.exports = __webpack_public_path__ + "static/img/9.b9ef3ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ment/333/22/9.png
// module id = NQw/
// module chunks = 0